export const actionOptions = [
  {
    value: 'suspendUser',
    displayValue: 'Suspend User',
    type: 'User',
    description: 'The user will be suspended when this rule is triggered.',
  },
  {
    value: 'runPolicy',
    displayValue: 'Run Policy',
    type: 'Policy',
    description: 'The selected policy will be run when this rule is triggered.',
  },
  //     { value: 'callEndpoint', displayValue: 'Call Endpoint', type: 'External' },
  {
    value: 'changePassword',
    displayValue: 'Change Password',
    type: 'User',
    description:
      "The user's password will be changed when this rule is triggered.",
  },
  {
    value: 'resetPassword',
    displayValue: 'Reset Password',
    type: 'User',
    description:
      "The user's password will be reset when this rule is triggered.",
  },
  {
    value: 'signOut',
    displayValue: 'Sign Out User',
    type: 'User',
    description: 'The user will be signed out when this rule is triggered.',
  },
  {
    value: 'changeCalendarTimezone',
    displayValue: 'Change Calendar Timezone',
    type: 'User',
    description:
      "The user's calendar's timezone will be changed when this rule is triggered.",
  },
  {
    value: 'sendEmail',
    displayValue: 'Send Email',
    type: 'External',
    description:
      'An email will be sent when the rule is triggered. You can use the provided template variables in the email subject or body.',
  },
  {
    value: 'sendChatMessage',
    displayValue: 'Send Chat Message',
    type: 'External',
    description:
      'This will send a message to the specified Google chat space when triggered.',
  },
  {
    value: 'limitOccurrences',
    displayValue: 'Limit Number of Occurrences',
    type: 'Resource Calendar',
    description: 'Limit the number of event occurrences on calendars.',
  },
  {
    value: 'addToGroup',
    displayValue: 'Add to Group',
    type: 'Group',
    description: 'Add user to specified group(s).',
  },
  {
    value: 'applyGroupTemplate',
    displayValue: 'Apply Group Template',
    type: 'Group',
    description: 'Apply a group template to the newly created group.',
  },
  {
    value: 'sendEmailTemplate',
    displayValue: 'Send Email With Template',
    type: 'User',
    description: 'Send email using existing welcome templates.',
  },
  {
    value: 'deleteGroup',
    displayValue: 'Delete Group',
    type: 'Group',
    description: 'The group will be deleted when this rule is triggered.',
  },
  {
    value: 'removeFromGroup',
    displayValue: 'Remove from Group',
    type: 'Group',
    description: 'Remove user from specified group(s).',
  },
  {
    value: 'removeShare',
    displayValue: 'Remove Share',
    type: 'Drive',
    description: 'The share will be removed when this rule is triggered.',
  },
];
